import { render, staticRenderFns } from "./CDActivityVolumeSection.vue?vue&type=template&id=7baa53ca&scoped=true"
import script from "./CDActivityVolumeSection.vue?vue&type=script&lang=ts"
export * from "./CDActivityVolumeSection.vue?vue&type=script&lang=ts"
import style0 from "./CDActivityVolumeSection.vue?vue&type=style&index=0&id=7baa53ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7baa53ca",
  null
  
)

export default component.exports